/**
 * Last known value of the §Emergency Brake, cached at module scope.
 *
 * Why a module global rather than context: `decodeContractError` is a pure
 * util called from dozens of catch blocks, not a component, so it cannot use
 * a hook. During a freeze some reverts arrive with NO decodable revert data at
 * all — a deposit sent with an explicit gasLimit fails on-chain and ethers
 * surfaces its own "could not coalesce error" wrapper instead. Showing that
 * string to a user is useless; knowing the protocol is frozen turns it into a
 * real explanation.
 *
 * `useProtocolHealth` writes this on every poll.
 */
let frozen = false;

export function setProtocolFrozen(value) {
    frozen = Boolean(value);
}

export function isProtocolFrozen() {
    return frozen;
}

/** Single source of truth for the frozen-state copy shown to users. */
export const PROTOCOL_FROZEN_MESSAGE =
    "The protocol is temporarily frozen by its emergency brake while an incident is investigated. " +
    "Deposits, withdrawals and exits are all paused for now. Nothing has been moved or taken — your " +
    "balance is unchanged and interest keeps accruing while the freeze is in place. Lifting it " +
    "requires confirmation from every multisig signer.";
